module.exports = __webpack_public_path__ + "frontend/images/miles/business-card-hand-x2-xs-fc699a8c28112dbddbd82e369a2f3726.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/miles/business-card-hand-x2-xs.png
// module id = 328
// module chunks = 2